import { render, staticRenderFns } from "./select-music.vue?vue&type=template&id=b907f188&scoped=true&"
import script from "./select-music.vue?vue&type=script&lang=js&"
export * from "./select-music.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b907f188",
  null
  
)

export default component.exports